import { render, staticRenderFns } from "./SocialNetworks.vue?vue&type=template&id=3fc0dd95&scoped=true&"
import script from "./SocialNetworks.vue?vue&type=script&lang=js&"
export * from "./SocialNetworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc0dd95",
  null
  
)

export default component.exports